<template>
  <div class="cooperation-my-report-change-cp-container">
    <div class="report-text-container" @click="handDetail">
      <div class="report-title-banner">
        <span class="left-title">{{ item.pactName }}</span>
      </div>
      <div class="report-text-content">
        <span>所属公司：</span>
        <span>{{ item.theirCompany }}</span>
      </div>
      <div v-if="!item.approvedate">
        <div class="report-text-content">
          <span>申报日期：</span>
          <span>{{
            item.applydate && moment(item.applydate).format('YYYY-MM-DD')
          }}</span>
        </div>
        <div class="report-text-content">
          <span>申报金额：</span>
          <span style="color:#36C490">{{ item.applyamount | money2 }}</span>
        </div>
      </div>
    </div>
    <div v-if="item.approvedate">
      <div class="date">
        <div>
          <span>申报日期：</span
          ><span>{{
            item.applydate && moment(item.applydate).format('YYYY-MM-DD')
          }}</span>
        </div>
        <div>
          <span>审核日期：</span
          ><span>{{
            item.approvedate && moment(item.approvedate).format('YYYY-MM-DD')
          }}</span>
        </div>
      </div>
      <div class="examined">
        <div>
          <span>{{ item.applyamount | money2 }}</span
          ><span>申报金额</span>
        </div>
        <div>
          <span>{{ item.approveamount | money2 }}</span
          ><span>审定金额</span>
        </div>
        <div>
          <span style="color:#C18858">{{ item.scheduleamount | money2 }}</span
          ><span>实际应付进度款</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { getUrlParams } from 'common/js/mUtils';

export default {
  name: 'cooperation-my-report-change-cp',

  data() {
    return {
      moment
    };
  },
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },
  mounted() {},

  components: {},

  methods: {
    handDetail() {
      let { item } = this;
      let { contractguid } = item;
      let { employeeName, mobile } = getUrlParams();

      this.$router.push({
        name: 'cooperationDetail',
        query: {
          contractguid,
          index: 0,
          employeeName: decodeURIComponent(employeeName),
          mobile
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
.cooperation-my-report-change-cp-container {
  padding-bottom: 30px;
  .report-text-container {
    padding: 20px;
    position: relative;

    .report-title-banner {
      .left-title {
        width: 100%;
        color: #000000;
        font-size: 28px;
        display: inline-block;
        line-height: 1.5;
      }
      .right-icon {
        width: 120px;
        height: 40px;
        font-size: 22px;
        color: white;
        line-height: 40px;
        text-align: center;
        background: #36c490;
        display: inline-block;
        position: absolute;
        right: 0;
      }
    }
    .report-text-content {
      font-size: 26px;
      margin-top: 10px;
      display: flex;
      span:nth-child(1) {
        color: #999;
        width: 140px;
        display: inline-block;
        line-height: 1.5;
      }
      span:nth-child(2) {
        max-width: 100%;
        line-height: 1.5;
        flex: 1;
        color: #666666;
      }
    }
  }
  .report-banner {
    padding: 20px;
    .report-title {
      height: 150px;
      background: rgba(239, 239, 239, 0.38);
      display: flex;
      width: 100%;
      padding: 20px;
      font-size: 24px;
      .left {
        width: 50%;
        height: 110px;
        border-right: 1px solid #efefef;
        overflow: hidden;
        padding-right: 30px;
        span {
          color: #000000;
          float: right;
        }
        p {
          margin-top: 15px;
          color: #666666;
        }
        p:nth-child(1) {
          margin-top: 0;
        }
      }
      .right {
        height: 110px;
        width: 50%;
        padding-left: 20px;
        overflow: hidden;
        padding-right: 30px;
        span {
          color: #c18858;
          float: right;
        }
        p {
          margin-top: 15px;
        }
        p:nth-child(1) {
          margin-top: 0;
        }
      }
    }
  }
  .date {
    height: 40px;
    background: rgba(239, 239, 239, 0.38);

    margin: 0px 40px 20px 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    div {
      display: flex;
      color: #666;
      font-size: 24px;
      padding: 0px 12px;
    }
  }
  .examined {
    display: flex;
    justify-content: space-around;
    text-align: center;
    div {
      display: flex;
      flex-direction: column;
      position: relative;
      span:nth-child(1) {
        color: #000000;
        font-size: 26px;
        font-weight: 600;
      }
      span:nth-child(2) {
        color: #666;
        font-size: 24px;
        margin-top: 16px;
      }
    }
    div::after {
      position: absolute;
      content: '';
      border: 1px solid #f1f1f1;
      right: -50px;
      top: 6px;
      height: 50px;
      transform: scaleX(0.5);
    }
    div:nth-child(3)::after {
      border: none;
    }
  }
}
</style>
